import { useQuery } from '@tanstack/react-query';
import { emailApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Emails synced for a job, optionally narrowed to one workflow record. */
export function useEmails(jobNumber: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.emails.forJob(jobNumber ?? ''),
    queryFn: ({ signal }) =>
      emailApiClient.list({ jobNumber: jobNumber! }, toCancelToken(signal)),
    enabled: !!jobNumber,
    meta: { errorContext: 'job emails' },
  });
}

export function useRecordEmails(
  jobNumber: string | null | undefined,
  productType: string | null | undefined,
  productNumber: string | null | undefined,
) {
  return useQuery({
    queryKey: queryKeys.emails.forRecord(
      jobNumber ?? '',
      productType ?? '',
      productNumber ?? '',
    ),
    queryFn: ({ signal }) =>
      emailApiClient.list(
        {
          jobNumber: jobNumber!,
          productType: productType!,
          productNumber: productNumber!,
        },
        toCancelToken(signal),
      ),
    enabled: !!jobNumber && !!productType && !!productNumber,
    meta: { errorContext: 'record emails' },
  });
}
